__turbopack_context__.v({
  "trustDescription": "styles-module__i8dXAa__trustDescription",
  "trustSignal": "styles-module__i8dXAa__trustSignal",
  "trustSignalDescription": "styles-module__i8dXAa__trustSignalDescription",
  "trustSignalLink": "styles-module__i8dXAa__trustSignalLink",
});
